import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  doLogin ({ state }) {
    let obj = state.user
    return new Promise((resolve, reject) => {
      axios.post('admin/login', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  GetSubjectList ({ state, commit }) {
    axios.get('subject/getSubjectlist')
      .then(response => {
        state.subjectList = response.data
        commit('setSubjectList', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  }

}
